export class LocalStorageService {
  private static readonly prefix: string = 'semeris-';

  public static get<T>(key: string): T {
    const plain = localStorage.getItem(`${LocalStorageService.prefix}${key}`);

    if (plain) {
      return JSON.parse(plain) as T;
    } else {
      return null;
    }
  }

  public static set<T>(value: T, key: string, force = false): void {
    try {
      const plain = JSON.stringify(value);
      localStorage.setItem(`${LocalStorageService.prefix}${key}`, plain);
    } catch (err) {
      if (err instanceof DOMException && (err.code === 22 || err.code === 1014)) {
        if (force) {
          this.clear();
          this.set(value, key);
        } else {
          const clear = confirm(
            'Local storage is full. If you press OK we will clear your local storage, it RESETS your editor and you lose all pending changes.'
          );
          if (clear) {
            this.clear();
            window.location.reload();
          }
          throw new Error('Local storage is full. Automatic clear is ignored by user.');
        }
      } else {
        throw err;
      }
    }
  }

  public static remove(key: string): void {
    localStorage.removeItem(`${LocalStorageService.prefix}${key}`);
  }

  public static clear(): void {
    localStorage.clear();
  }
}
